// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"221de882","583":"e89bb51b","700":"615f0ae8","734":"49f2f629"}[chunkId] + ".chunk.js";
};